// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__5dIMI","additionalInfo":"AgreementModal_additionalInfo__Vv6S0"};